












export default {
    name: 'ArticleVideo'

    props: ['document']

    data: ->
        fields: @defaultFields()

    methods:
        defaultFields: ->
            width: 'Seite',
            video: []
            description: []

        setContent: (document) ->
            fields =
                video: document.primary.video
                description: document.primary.description
            $.extend @fields, fields
    
    created: ->
        @setContent @document
}
